module.exports = __webpack_public_path__ + "static/img/contect_4.4e0468c6.jpg";